import { gql } from "src/__generated__";

export const GET_MY_PORTFOLIO_FOR_JOB_APPLICATION_PREFILL = gql(`
  query MyPortfolioForJobApplicationPrefill {
    myPortfolio {
      workHistory {
        id
        name
        description
        startedAt
        endedAt
        images {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        images {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
      }
      certifications {
        id
        name
        issuedBy
        issuedAt
        issuerCertificationId
        url
      }
			educationEntries {
				id
				schoolName
				fieldOfStudy
				qualification
      }
    }
  }
`);

/**
 * Get all my job applications (recruiter jobs and community job opportunities)
 */
export const GET_MY_JOB_APPLICATIONS = gql(`
  query AllMyJobApplications($limit: Float) {
    allMyJobApplications(limit: $limit) {
      id
      ad {
        companyName
        organization {
          name
        }
        principal {
          name
        }
        title
        id
      }
      communityJobOpportunity {
        id
        title
        organization {
          name
        }
      }
      status
      enhancementRequested
      education {
        id
        schoolName
        fieldOfStudy
        qualification
        createdAt
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        createdAt
      }
      projectHistory {
        id
        name
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        videos
        createdAt
      }
      certifications {
        id
        name
        issuerCertificationId
        issuedBy
        issuedAt
        url
        createdAt
      }
      createdAt
    }
  }
`);

/**
 * Get recruiter job ad for application
 */
export const GET_JOB_AD = gql(`
  query GetJobAdForApplication($id: String!) {
    getEmployerJobAd(id: $id) {
      id
      title
      description
      employmentType
      companyName
      organization {
        name
      }
      principal {
        name
      }
      location {
        area
        state
        country
      }
      salaryDetails {
        starting
        cap
        currencyCode
      }
      duration {
        value
        type
      }
      tags {
        id
        name
      }
      categories {
        name
      }
      applicationDeadline
      hasApplied
      canApply
      createdAt
    }
  }
`);

/**
 * Get all recruiter (employer) job ads
 */
export const GET_EMPLOYER_JOB_ADS =
	gql(`query GetEmployerJobAds($dateFilter: EmployerJobAdsDateFilter, $employmentTypes: [EmploymentType!]!) {
  getEmployerJobAds(dateFilter: $dateFilter, employmentTypes: $employmentTypes)  {
    companyName
    categories {
      name
    }
    tags {
      id
      name
    }
    applicationDeadline
    location {
      area
      state
      country
    }
    title
    salary
    salaryDetails {
      starting
      cap
      currencyCode
    }
    id
    principal {
      name
    }
    organization {
      name
    }
    visibility
    employmentType
    createdAt
    description
    hasApplied
    canApply
    duration {
      value
      type
    }
  }
}`);

/**
 * Create application for job posted by a recruiter
 */
export const CREATE_RECRUITER_JOB_APPLICATION_LOGGED_IN = gql(`
  mutation CreateRecruiterJobApplicationLoggedIn($input: CreateJobApplicationDto!) {
    createRecruiterJobApplicationLoggedIn(input: $input) {
      id
      status
      createdAt
    }
  }
`);
